export default __webpack_public_path__ + "static/media/scarecrow.075c4381.png";